<script setup lang="ts">
const menuItems = [
  { name: 'Home', href: '#' },
  { name: 'Products', href: '#products' },
  { name: 'Science', href: '#science' },
  { name: 'Contact', href: '#contact' }
]

const scrollToSection = (href: string) => {
  if (href === '#') {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    return
  }

  const element = document.querySelector(href)
  if (element) {
    const headerOffset = 80 // Height of the fixed header
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}
</script>

<template>
  <header class="header">
    <nav class="container">
      <a href="#" class="logo" @click.prevent="scrollToSection('#')">
        <span class="logo-text">Krilom</span>
      </a>
      <ul class="menu">
        <li v-for="item in menuItems" :key="item.name">
          <a 
            :href="item.href" 
            class="menu-item"
            @click.prevent="scrollToSection(item.href)"
          >
            {{ item.name }}
          </a>
        </li>
      </ul>
    </nav>
  </header>
</template>